import useInitialize from "./useInitialize";
import useExecute from "./useExecute";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import { GeneratePDFContext } from "./GeneratePDFContext";

function useGeneratePDFAction(index: any): any {
  const initialize = useInitialize();
  const initializeFunction = (id: number) => initialize(id);

  const onSuccessExecute = () => {
    setShowModal(false);
    index();
  };

  const execute = useExecute();

  const executeFunction = () => execute(onSuccessExecute);

  const contextInstance = useContext(GeneratePDFContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: t("generate_pdf"),
    onSubmit: () => executeFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t("are_you_sure_you_want_to_generete_the_delivery_note_pdf?")}
    </CrudModuleFactoryModal>
  );

  return {
    initializeFunction,
    actionTemplate,
  };
}

export default useGeneratePDFAction;
